import { Shimmer } from '@components';

import { Container, Title, Head, LineDivider } from './Contacts.styles';

export const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 22, width: 22, borderRadius: 4 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export const ContactsLoading = () => {
  return (
    <Container>
      <Head>
        <Title>Contacts</Title>
      </Head>

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 6,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <LineDivider />

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
          marginTop: 6,
          marginBottom: 6,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <LineDivider />

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
          marginTop: 6,
          marginBottom: 6,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};
